import React, { Fragment } from 'react'
import { Fonts } from '@kawaui/theme'
import { Container, Content, GlobalStyle } from './style'

const AppWrapper: React.FC = ({ children }) => (
  <Fragment>
    <GlobalStyle />
    <Fonts />
    <Container id='container'>
      <Content id='content' role='main'>
        {children}
      </Content>
    </Container>
  </Fragment>
)

export default AppWrapper
